module.exports = __webpack_public_path__ + "static/img/Africa-blue.ae2d927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Africa-blue.png
// module id = 5S4c
// module chunks = 1